"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _scss = require("@scss");

var _Cell = _interopRequireDefault(require("@components/Cell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Table = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var headers = _ref.headers,
      rows = _ref.rows,
      rowHeaders = _ref.rowHeaders,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    table: ''
  } : _ref$classes,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("table", {
    className: (0, _scss.cls)(_stylesModule["default"]['table'], classes === null || classes === void 0 ? void 0 : classes.table, className)
  }, headers && headers.length ? /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, headers.map(function (h, i) {
    return /*#__PURE__*/_react["default"].createElement(_Cell["default"], {
      key: i,
      component: "th",
      scope: "col"
    }, h);
  }))) : null, rows && rows.length ? /*#__PURE__*/_react["default"].createElement("tbody", null, rows.map(function (r, i) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: i
    }, rowHeaders && rowHeaders.length ? /*#__PURE__*/_react["default"].createElement(_Cell["default"], {
      component: "th",
      scope: "row"
    }, rowHeaders[i]) : null, r.map(function (c, ii) {
      return /*#__PURE__*/_react["default"].createElement(_Cell["default"], {
        key: ii,
        component: "td"
      }, c);
    }));
  })) : null);
});
var _default = Table;
exports["default"] = _default;